import React from 'react';
import { useEffect } from 'react';
import { initClarity } from './services/clarity';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  useEffect(() => {
    // redirecting proxy 
    if (window.location.hostname === 'metromowingmn.com') {
      console.log('redirecting to www version...');
      
      window.location.replace('https://www.metromowingmn.com'+window.location.pathname+window.location.search)
      
    }
    // Initialize Clarity when the app loads
    initClarity();
  }, []);

  return (
    <div className="App">
      {/* SEO Meta Tags - Add to public/index.html */}
      <Header />
      <Hero />
      <Services />
      <WhyChooseUs />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;